/**
 * 运营 - 同步商户信息 - 同步信息填写页
 * 4.2 图片上传 -> 后端 lg1212 -> 返回 imgUrl
 * 4.3 表单填写 -> 后端 lg1213 -> 子商户信息同步
 */
<template>
  <div class="merchant-sync-info-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/oms/merchantSync' }">同步商户信息</el-breadcrumb-item>
      <el-breadcrumb-item>同步信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card shadow="hover" class="info-card" v-loading="loading" element-loading-text="加载中...">
      <el-form
        ref="syncFormRef"
        :model="form"
        :rules="rules"
        label-width="140px"
        size="small"
        class="sync-form"
      >
        <div class="section-title">企业基本信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商户名称" prop="merchantId">
              <el-select
                v-model="form.merchantId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入商户名称搜索"
                :remote-method="searchMerchantName"
                :loading="merchantSearchLoading"
                style="width: 100%"
                clearable
                @change="onMerchantChange"
              >
                <el-option
                  v-for="item in merchantList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户简称" prop="subNickName">
              <el-input v-model="form.subNickName" placeholder="请输入商户简称" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册资本(万元)" prop="registeredCapital">
              <el-input v-model="form.registeredCapital" placeholder="请输入注册资本" clearable maxlength="10" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一信用代码" prop="businessCode">
              <el-input v-model="form.businessCode" placeholder="请输入统一信用代码" clearable maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册省" prop="registerProvince">
              <el-select
                v-model="form.registerProvince"
                placeholder="请选择注册省"
                clearable
                filterable
                style="width: 100%"
                @change="onProvinceChange"
              >
                <el-option
                  v-for="item in province_list"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册市" prop="registerCity">
              <el-select
                v-model="form.registerCity"
                placeholder="请先选择注册省"
                clearable
                filterable
                style="width: 100%"
                :disabled="!city_list.length"
              >
                <el-option
                  v-for="item in city_list"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注册场所地址" prop="registerAddress">
              <el-input v-model="form.registerAddress" placeholder="请输入注册场所地址" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="经营场所地址" prop="businessAddress">
              <el-input v-model="form.businessAddress" placeholder="请输入经营场所地址" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="行业类别" prop="industryType">
              <el-input v-model="form.industryType" placeholder="请输入行业类别" clearable maxlength="100" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="经营范围" prop="businessScope">
              <el-input
                v-model="form.businessScope"
                type="textarea"
                :rows="3"
                placeholder="请输入经营范围"
                maxlength="800"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户许可证号" prop="licenceNumber">
              <el-input v-model="form.licenceNumber" placeholder="请输入开户许可证号" clearable maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照有效期" prop="businessValidDate">
              <el-date-picker
                v-model="form.businessValidDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择营业执照有效期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系电话" prop="companyMobile">
              <el-input v-model="form.companyMobile" placeholder="请输入企业联系电话" clearable maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业开户行名称" prop="accountBank">
              <el-input v-model="form.accountBank" placeholder="请输入企业开户行名称" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业开户账号" prop="settleAccountNo">
              <el-input v-model="form.settleAccountNo" placeholder="加密传输，由后端处理" clearable maxlength="128" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">费率与税源地</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="税源地名称" prop="providerId">
              <el-select
                v-model="form.providerId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入税源地名称搜索"
                :remote-method="searchProviderName"
                :loading="providerSearchLoading"
                style="width: 100%"
                clearable
                @change="onProviderChange"
              >
                <el-option
                  v-for="item in providerList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税源地编码" prop="providerCode">
              <el-input v-model="form.providerCode" placeholder="请输入税源地编码" clearable maxlength="16" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费率类型" prop="feeType">
              <el-select v-model="form.feeType" placeholder="请选择费率类型" style="width: 100%">
                <el-option label="小额" value="0" />
                <el-option label="大额" value="1" />
                <el-option label="大小额" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费率(%)" prop="feeRate">
              <el-input
                v-model="form.feeRate"
                :placeholder="form.feeType === '2' ? '如：6,8（小额,大额）' : '如：6 表示 6%'"
                clearable
                maxlength="20"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">任务信息</div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="任务名称" prop="taskName">
              <el-input v-model="form.taskName" placeholder="请输入任务名称" clearable maxlength="800" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="任务描述" prop="taskDesc">
              <el-input
                v-model="form.taskDesc"
                type="textarea"
                :rows="3"
                placeholder="请输入任务描述"
                maxlength="800"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">法人信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法人姓名" prop="legerName">
              <el-input v-model="form.legerName" placeholder="加密传输，由后端处理" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人证件号" prop="legerCertNo">
              <el-input v-model="form.legerCertNo" placeholder="加密传输，由后端处理" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人证件有效期" prop="legerCertEndDate">
              <el-date-picker
                v-model="form.legerCertEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择法人证件有效期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人手机" prop="legerMobile">
              <el-input v-model="form.legerMobile" placeholder="请输入法人手机" clearable maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人邮箱" prop="legerEmail">
              <el-input v-model="form.legerEmail" placeholder="请输入法人邮箱" clearable maxlength="30" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">管理员信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="管理员姓名" prop="adminName">
              <el-input v-model="form.adminName" placeholder="加密传输，由后端处理" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="管理员证件号" prop="adminCertNo">
              <el-input v-model="form.adminCertNo" placeholder="加密传输，由后端处理" clearable maxlength="128" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="管理员手机号" prop="adminMobile">
              <el-input v-model="form.adminMobile" placeholder="请输入管理员手机号" clearable maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="管理员邮箱" prop="adminEmail">
              <el-input v-model="form.adminEmail" placeholder="请输入管理员邮箱" clearable maxlength="30" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">证件图片同步</div>
        <el-row :gutter="24" class="image-upload-row">
          <el-col
            v-for="item in imageUploadList"
            :key="item.imgType"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
          >
            <div class="image-upload-card">
              <div class="image-upload-label">{{ item.label }}</div>
              <div v-if="form[item.field]" class="uploaded-image-wrap">
                <div class="image-preview-box">
                  <el-image
                    :ref="'certImage_' + item.imgType"
                    :src="form[item.field]"
                    fit="contain"
                    class="cert-thumbnail"
                    :preview-src-list="[form[item.field]]"
                  >
                    <div slot="error" class="image-slot-error">
                      <i class="el-icon-picture-outline" />
                      <span>图片加载失败</span>
                    </div>
                  </el-image>
                  <div class="image-action-mask">
                    <span
                      class="action-icon"
                      title="预览"
                      @click.stop="handlePreviewImage(item)"
                    >
                      <i class="el-icon-zoom-in" />
                    </span>
                    <el-upload
                      class="image-action-upload"
                      action="#"
                      :show-file-list="false"
                      accept=".png,.jpg,.jpeg"
                      :disabled="!canUploadImage || item.uploading"
                      :before-upload="(file) => beforeImageUpload(item, file)"
                    >
                      <span
                        class="action-icon"
                        :class="{ 'is-disabled': !canUploadImage || item.uploading }"
                        title="重新上传"
                      >
                        <i :class="item.uploading ? 'el-icon-loading' : 'el-icon-upload2'" />
                      </span>
                    </el-upload>
                  </div>
                </div>
              </div>
              <el-upload
                v-else
                class="cert-uploader"
                action="#"
                :show-file-list="false"
                accept=".png,.jpg,.jpeg"
                :disabled="!canUploadImage || item.uploading"
                :before-upload="(file) => beforeImageUpload(item, file)"
              >
                <div class="upload-placeholder" :class="{ 'is-disabled': !canUploadImage }">
                  <i :class="item.uploading ? 'el-icon-loading' : 'el-icon-plus'" />
                  <span>{{ item.uploading ? '上传中...' : (canUploadImage ? '上传图片' : '请先填写商户、税源地及编码') }}</span>
                </div>
              </el-upload>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="action-bar">
        <el-button size="small" icon="el-icon-back" @click="goBack">返回</el-button>
        <el-button size="small" type="primary" :loading="submitting" @click="submitSync">
          提交同步
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getMerchantSyncDetail,
  uploadMerchantSyncImage,
  submitMerchantSync,
  getCompanyNameList
} from '../../api/userMG';
import { china } from '../../common/area.js';

const MUNICIPALITY_PROVINCES = ['北京市', '天津市', '上海市', '重庆市'];

function createDefaultForm() {
  return {
    merchantId: '',
    merchantName: '',
    providerId: '',
    providerName: '',
    providerCode: '',
    feeType: '',
    feeRate: '',
    subMerchantName: '',
    subNickName: '',
    registeredCapital: '',
    businessCode: '',
    registerProvince: '',
    registerCity: '',
    registerAddress: '',
    businessAddress: '',
    industryType: '',
    businessScope: '',
    licenceNumber: '',
    businessValidDate: '',
    companyMobile: '',
    accountBank: '',
    settleAccountNo: '',
    taskName: '',
    taskDesc: '',
    legerName: '',
    legerCertNo: '',
    legerCertEndDate: '',
    legerMobile: '',
    legerEmail: '',
    adminName: '',
    adminCertNo: '',
    adminMobile: '',
    adminEmail: '',
    legalCodeFrontUrl: '',
    legalCodeBackUrl: '',
    licenseImgUrl: '',
    openLicenseUrl: ''
  };
}

const requiredRule = (message) => [{ required: true, message, trigger: 'blur' }];

export default {
  name: 'MerchantSyncInfo',
  data() {
    return {
      loading: false,
      submitting: false,
      merchantSearchLoading: false,
      providerSearchLoading: false,
      merchantList: [],
      providerList: [],
      province_list: [],
      city_list: [],
      form: createDefaultForm(),
      imageUploadList: [
        { imgType: '00', label: '法人身份证正面', field: 'legalCodeFrontUrl', uploading: false },
        { imgType: '01', label: '法人身份证反面', field: 'legalCodeBackUrl', uploading: false },
        { imgType: '02', label: '营业执照', field: 'licenseImgUrl', uploading: false },
        { imgType: '03', label: '开户许可证', field: 'openLicenseUrl', uploading: false }
      ],
      rules: {
        merchantId: [{ required: true, message: '请选择商户名称', trigger: 'change' }],
        providerId: [{ required: true, message: '请选择税源地名称', trigger: 'change' }],
        providerCode: requiredRule('请输入税源地编码'),
        feeType: requiredRule('请选择费率类型'),
        feeRate: requiredRule('请输入费率'),
        subNickName: requiredRule('请输入商户简称'),
        registeredCapital: requiredRule('请输入注册资本'),
        businessCode: requiredRule('请输入统一信用代码'),
        registerProvince: [{ required: true, message: '请选择注册省', trigger: 'change' }],
        registerCity: [{ required: true, message: '请选择注册市', trigger: 'change' }],
        registerAddress: requiredRule('请输入注册场所地址'),
        businessAddress: requiredRule('请输入经营场所地址'),
        industryType: requiredRule('请输入行业类别'),
        businessScope: requiredRule('请输入经营范围'),
        licenceNumber: requiredRule('请输入开户许可证号'),
        businessValidDate: requiredRule('请选择营业执照有效期'),
        companyMobile: requiredRule('请输入企业联系电话'),
        accountBank: requiredRule('请输入企业开户行名称'),
        settleAccountNo: requiredRule('请输入企业开户账号'),
        taskName: requiredRule('请输入任务名称'),
        taskDesc: requiredRule('请输入任务描述'),
        legerName: requiredRule('请输入法人姓名'),
        legerCertNo: requiredRule('请输入法人证件号'),
        legerCertEndDate: requiredRule('请选择法人证件有效期'),
        legerMobile: requiredRule('请输入法人手机'),
        legerEmail: requiredRule('请输入法人邮箱'),
        adminName: requiredRule('请输入管理员姓名'),
        adminCertNo: requiredRule('请输入管理员证件号'),
        adminMobile: requiredRule('请输入管理员手机号'),
        adminEmail: requiredRule('请输入管理员邮箱')
      }
    };
  },
  computed: {
    queryParams() {
      return this.$route.query || {};
    },
    canUploadImage() {
      return !!(
        this.form.merchantId &&
        this.form.providerId &&
        this.form.providerCode &&
        String(this.form.providerCode).trim()
      );
    }
  },
  created() {
    this.province_list = china;
    this.initPage();
  },
  methods: {
    onProvinceChange(provinceName) {
      this.form.registerCity = '';
      this.syncCityListFromProvince(provinceName);
    },
    syncCityListFromProvince(provinceName) {
      const name = provinceName || this.form.registerProvince;
      if (!name) {
        this.city_list = [];
        return;
      }
      const province = this.province_list.find((item) => item.name === name);
      if (province && MUNICIPALITY_PROVINCES.includes(name)) {
        const districtCity = (province.city || []).find((item) => item.name === '市辖区');
        this.city_list = [
          { name: province.name, code: province.code },
          districtCity || { name: '市辖区', code: '' }
        ];
        return;
      }
      this.city_list = province && province.city ? province.city : [];
    },
    initPage() {
      const { merchantId, providerId, merchantName, providerName } = this.queryParams;
      if (merchantId) {
        this.form.merchantId = isNaN(Number(merchantId)) ? merchantId : Number(merchantId);
        if (merchantName) {
          this.form.merchantName = merchantName;
          this.form.subMerchantName = merchantName;
          this.merchantList = [{ value: this.form.merchantId, label: merchantName }];
        }
      }
      if (providerId) {
        this.form.providerId = isNaN(Number(providerId)) ? providerId : Number(providerId);
        if (providerName) {
          this.form.providerName = providerName;
          this.providerList = [{ value: this.form.providerId, label: providerName }];
        }
      }
      this.loadDetail();
    },
    searchMerchantName(query) {
      if (!query) {
        this.merchantList = this.form.merchantId && this.form.merchantName
          ? [{ value: this.form.merchantId, label: this.form.merchantName }]
          : [];
        return;
      }
      this.merchantSearchLoading = true;
      getCompanyNameList({
        page: 1,
        pageSize: 9999,
        type: 1,
        companyName: query
      })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            this.merchantList = res.data || [];
          } else {
            this.merchantList = [];
            this.$message.error((res && (res.msg || res.message)) || '搜索商户失败');
          }
        })
        .catch((err) => {
          this.merchantList = [];
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '搜索商户失败');
        })
        .finally(() => {
          this.merchantSearchLoading = false;
        });
    },
    searchProviderName(query) {
      if (!query) {
        this.providerList = this.form.providerId && this.form.providerName
          ? [{ value: this.form.providerId, label: this.form.providerName }]
          : [];
        return;
      }
      this.providerSearchLoading = true;
      getCompanyNameList({
        page: 1,
        pageSize: 9999,
        type: 2,
        companyName: query
      })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            this.providerList = res.data || [];
          } else {
            this.providerList = [];
            this.$message.error((res && (res.msg || res.message)) || '搜索服务商失败');
          }
        })
        .catch((err) => {
          this.providerList = [];
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '搜索服务商失败');
        })
        .finally(() => {
          this.providerSearchLoading = false;
        });
    },
    onMerchantChange(val) {
      const item = this.merchantList.find((i) => i.value === val);
      this.form.merchantName = item ? item.label : '';
      this.form.subMerchantName = item ? item.label : '';
      this.clearImageUrls();
    },
    onProviderChange(val) {
      const item = this.providerList.find((i) => i.value === val);
      this.form.providerName = item ? item.label : '';
      this.clearImageUrls();
    },
    clearImageUrls() {
      this.form.legalCodeFrontUrl = '';
      this.form.legalCodeBackUrl = '';
      this.form.licenseImgUrl = '';
      this.form.openLicenseUrl = '';
    },
    ensureSelectOption(listKey, id, name) {
      if (!id || !name) return;
      const list = this[listKey];
      const exists = list.some((item) => item.value === id);
      if (!exists) {
        this[listKey] = [{ value: id, label: name }].concat(list);
      }
    },
    loadDetail() {
      const { id, merchantNo, merchantId } = this.queryParams;
      if (!id && !merchantNo && !merchantId) return;
      this.loading = true;
      getMerchantSyncDetail({
        id: id || undefined,
        merchantNo: merchantNo || undefined,
        merchantId: merchantId || undefined
      })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.form = Object.assign(createDefaultForm(), this.form, data);
            if (data.merchantId) {
              this.form.merchantId = data.merchantId;
              const merchantLabel = data.merchantName || data.subMerchantName;
              if (merchantLabel) {
                this.form.merchantName = merchantLabel;
                this.form.subMerchantName = data.subMerchantName || merchantLabel;
              }
              this.ensureSelectOption('merchantList', data.merchantId, merchantLabel);
            }
            if (data.providerId) {
              this.form.providerId = data.providerId;
              this.ensureSelectOption('providerList', data.providerId, data.providerName);
            }
            this.syncCityListFromProvince();
          } else {
            this.$message.error((res && (res.msg || res.message)) || '获取同步信息失败');
          }
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '获取同步信息失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePreviewImage(item) {
      const imgRef = this.$refs['certImage_' + item.imgType];
      const elImage = Array.isArray(imgRef) ? imgRef[0] : imgRef;
      if (elImage && typeof elImage.clickHandler === 'function') {
        elImage.clickHandler();
      }
    },
    getImgSuffix(file) {
      const name = (file && file.name) || '';
      const ext = name.split('.').pop().toLowerCase();
      if (ext === 'png') return 'png';
      if (ext === 'jpeg') return 'jpeg';
      return 'jpg';
    },
    beforeImageUpload(item, file) {
      if (!this.canUploadImage) {
        this.$message.warning('请先选择商户名称、税源地名称并填写税源地编码');
        return false;
      }
      const suffix = this.getImgSuffix(file);
      if (!['png', 'jpg', 'jpeg'].includes(suffix)) {
        this.$message.error('仅支持 png、jpg、jpeg 格式');
        return false;
      }
      this.handleImageUpload(item, file);
      return false;
    },
    handleImageUpload(item, file) {
      item.uploading = true;
      const suffix = this.getImgSuffix(file);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('imgType', item.imgType);
      formData.append('imgSuffix', suffix);
      formData.append('merchantId', this.form.merchantId);
      formData.append('providerId', this.form.providerId);
      formData.append('providerCode', this.form.providerCode);
      if (this.form.merchantName) formData.append('merchantName', this.form.merchantName);
      if (this.form.providerName) formData.append('providerName', this.form.providerName);

      uploadMerchantSyncImage(formData)
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            const imgUrl = data.imgUrl || data.url;
            if (!imgUrl) {
              this.$message.error('上传成功但未返回 imgUrl');
              return;
            }
            this.form[item.field] = imgUrl;
            this.$message.success(`${item.label}上传成功`);
          } else {
            this.$message.error((res && (res.msg || res.message)) || `${item.label}上传失败`);
          }
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || `${item.label}上传失败`);
        })
        .finally(() => {
          item.uploading = false;
        });
    },
    goBack() {
      this.$router.push({ path: '/oms/merchantSync' });
    },
    submitSync() {
      const missingImage = this.imageUploadList.find((item) => !this.form[item.field]);
      if (missingImage) {
        this.$message.warning(`请上传${missingImage.label}`);
        return;
      }
      this.$refs.syncFormRef.validate((valid) => {
        if (!valid) {
          this.$message.warning('请完善必填项');
          return;
        }
        this.$confirm('确认提交子商户信息同步？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.submitting = true;
            const payload = {
              ...this.form,
              merchantId: this.form.merchantId || undefined,
              providerId: this.form.providerId || undefined,
              merchantName: this.form.merchantName || undefined,
              providerName: this.form.providerName || undefined
            };
            submitMerchantSync(payload)
              .then((res) => {
                if (res && (res.msg === 'success' || res.code === 0)) {
                  this.$message.success('同步请求已提交');
                  this.$router.push({ path: '/oms/merchantSync' });
                } else {
                  this.$message.error((res && (res.msg || res.message)) || '同步失败');
                }
              })
              .catch((err) => {
                const data = err && err.response && err.response.data;
                this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '同步失败');
              })
              .finally(() => {
                this.submitting = false;
              });
          })
          .catch(() => {});
      });
    }
  }
};
</script>

<style scoped>
.merchant-sync-info-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.info-card {
  margin-top: 24px;
  border-radius: 8px;
}
.info-card >>> .el-card__body {
  padding: 20px;
}
.section-title {
  margin: 8px 0 16px;
  padding-left: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  border-left: 3px solid #409eff;
}
.section-title:not(:first-of-type) {
  margin-top: 24px;
}
.image-upload-row {
  margin-bottom: 8px;
}
.image-upload-card {
  margin-bottom: 16px;
}
.image-upload-label {
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}
.cert-uploader >>> .el-upload {
  width: 100%;
}
.uploaded-image-wrap {
  width: 100%;
}
.image-preview-box {
  position: relative;
  width: 100%;
  height: 140px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  background: #f5f7fa;
  overflow: hidden;
}
.uploaded-image-wrap >>> .el-image {
  width: 100%;
  height: 140px;
}
.uploaded-image-wrap >>> .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: default;
}
.image-action-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(0, 0, 0, 0.55);
  opacity: 0;
  transition: opacity 0.2s;
}
.image-preview-box:hover .image-action-mask {
  opacity: 1;
}
.action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}
.action-icon:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.08);
}
.action-icon.is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.action-icon.is-disabled:hover {
  transform: none;
  background: rgba(255, 255, 255, 0.2);
}
.image-action-upload {
  display: inline-flex;
}
.image-action-upload >>> .el-upload {
  width: auto;
  line-height: 1;
}
.image-slot-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 140px;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 12px;
}
.image-slot-error i {
  font-size: 24px;
  margin-bottom: 6px;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 140px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  color: #8c939d;
  cursor: pointer;
  overflow: hidden;
}
.upload-placeholder.is-disabled {
  cursor: not-allowed;
  background: #f5f7fa;
  color: #c0c4cc;
}
.upload-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
}
.sync-form >>> .el-form-item {
  margin-bottom: 16px;
}
.action-bar {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
.action-bar .el-button + .el-button {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/merchantSyncInfo.vue